module.exports = __webpack_public_path__ + "static/media/close-button-green.0e8ae7c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/svg/close-button-green.svg
// module id = 1321
// module chunks = 0